(function () {
    var tn = 'ACC_SCS_Menu_02';
    var selector = '#Details-menu-drawer-container #menu-drawer .menu-drawer__navigation-container>.menu-drawer__navigation>.menu-drawer__menu';
    var menuData = [
        {
            name: 'Home',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACC_SCS_Menu_02_005.webp?v=1757921555',
            link: '/'
        },
        {
            name: 'Seat <br>Covers',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACC_SCS_Menu_02_001.webp?v=1757921555',
            link: '/products/luxury-seat-covers'
        },
        {
            name: 'Steering Wheel <br>Covers',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACC_SCS_Menu_02_002.webp?v=1757921555',
            link: '/products/steering-wheel-cover'
        },
        {
            name: 'FAQ',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACC_SCS_Menu_02_003.webp?v=1757921555',
            link: '/pages/frequently-asked-questions'
        },
        {
            name: 'Our story',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACC_SCS_Menu_02_004.webp?v=1757921555',
            link: 'https://www.seatcoversolutions.com/pages/our-story'
        }
    ];

    function runAt(sel, callback) {
        function tryFind() {
            var el = document.querySelector(sel);
            if (el) {
                callback([el]);
                return true;
            }
            return false;
        }
        if (tryFind()) return;
        var observer = new MutationObserver(function () {
            if (tryFind()) observer.disconnect();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    function menuBlocks() {
        var itemsHTML = menuData.map(function (item) {
            return '<div class="' + tn + '_menu_item_card">' +
                '<a href="' + item.link + '">' +
                    '<img class="' + tn + '_menu_image" src="' + item.image + '" alt="' + item.name.replace(/<br>/g, ' ') + '" />' +
                    '<p class="' + tn + '_menu_text">' + item.name + '</p>' +
                '</a>' +
                '</div>';
        }).join('');
        return '<div class="' + tn + '_menuBlocks_wrap">' + itemsHTML + '</div>';
    }

    function init() {
        runAt(selector, function (els) {
            els[0].insertAdjacentHTML('afterend', menuBlocks());
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
